export default {
  home: {
    describe1: "Welcome to use",
    describe2: "Make the world just a fingertip away",
    describe3: "With perfect cross-platform solutions, it is based on network platform and adopts distributed regional management technology, which can effectively integrate various multimedia resources and achieve remote production, release and management of programs."
  },
  app: {
    more: "View More",
    PersonalCenter: "Personal Center",
    HelpDocument: "Help Document",
    LogOut: "LogOut",
    AddMaterial: "Add Material",
    CreateProgram: "Create Program",
    CreateRelease: "Create Release",
    AddTerminal: "Add Terminal",
    CreateAccount: "Create Account",
    Percent: "Percent",
    TerminalName: "Terminal Name",
    ReleaseSchedule: "Release Schedule",
    status: "Status",
    operate: "Operate",
    retransmission: "Rtns",
    Cancel: "Cancel",
    CancelAll: "CancelAll",
    AllRetransmission: "All Re-TXS",
    ClearanceToComplete: "Clear Complete",
    RemoveAll: "Remove All"
  },
  basics: {
    Cancel: "Cancel",
    Confirm: "Confirm",
    en: "EN",
    zh: "ZH",
    PleaseSelect: "Please select",
    PleaseInput: "Please input",
    materialCatalogue: "Material Catalogue",
    structureGrouping: "Structure Grouping",
    inStreamType: "In-stream type"
  },
  public: {
    search: "Please enter query keyword!"
  },
  router: {
    help: "Help",
    material: "Media",
    programme: "Programme",
    editProgramme: "Solution",
    publishProgramme: "Schedule",
    terminal: "Screen",
    check: "Check",
    checkMaterial: "Material",
    checkProgramme: "Programme",
    checkPublish: "Publish",
    log: "Logs",
    logLogin: "Login",
    logOperation: "Operation",
    logTerminal: "Terminal",
    seniorManagement: "Senior",
    organization: "Organization",
    userManage: "User",
    RoleManage: "Role",
    systemLayout: "System Layout",
    nodeManage: "Node Manage",
    reviewSet: "Review Set",
    softwareLicence: "Software Licence"
  },
  device: {},
  explorer: {
    clickUpload: "Drag files to here, or <em>click to Upload</em>",
    sizeLimit: "Single File Not Exceed ",
    video: "Video",
    picture: "Picture",
    uploadFiles: "Upload files",
    newFolder: "New folder",
    deleteFiles: "Delete files",
    materialAll: "All materials loaded",
    materialsLoaded: "Click to load material",
    move: "Move",
    copy: "Copy",
    delete: "Delete",
    all: "All",
    name: "Name",
    resolution: "Resolution",
    fileSize: "FileSize",
    creationTime: "Creation Time",
    operate: "Operate",
    FolderName: "FolderName",
    deleteFile: "IF delete currently selected file?",
    BackEdit: "Back to program edit",
    FileMove: "File Move",
    FileCopy: "File Copy",
    StartAll: "Start All",
    StopAll: "Stop All",
    EmptyFinish: "Empty Finish",
    CancelAll: "Cancel All",
    NoFiles: "No uploaded files yet",
    Status: "Status",
    Check: "Check",
    Stop: "Stop",
    Start: "Start",
    Cancel: "Cancel",
    finish: "finish"
  },
  log: {
    export: "Export",
    selectDevice: "Select device",
    deviceSn: "Device SN",
    operateTime: "Operate time",
    operateUser: "Operate user",
    function: "Function",
    describe: "Describe",
    dateArr: "Date range",
    startDate: "Start date",
    endDate: "End date",
    search: "Please enter query keyword!",
    searchTips: "Select a device to inquire",
    loadingTips: "The log is being acquired, please wait",
    no: "Code",
    content: "Content",
    operateObj: "Operation object",
    operateContent: "Operation information",
    selectTips1: "Only supports query data within three months",
    searchTips1: "Please select a terminal first, determine the time range, and query",
    exportTips: "Only data within query time range can be exported"
  },
  login: {
    Login: "Login",
    memberRegister: "Member register",
    ForgetThePassword: "Forget the password?",
    NoLogin: "No login for seven days",
    verification: "Please enter the verification code",
    account: "Please enter your account",
    password: "Please enter password",
    helpDocument: "Help"
  },
  manage: {},
  review: {
    Screenshot: "Preview",
    ProgramName: "Name",
    Structure: "Structure",
    Resolution: "Resolution",
    CreationTime: "Time",
    operate: "Operate",
    Review: "Review",
    Check: "Check",
    ProgramMaterial: "Program material",
    ProgramPreview: "Program preview",
    ReviewContent: "Please enter review content",
    Approved: "Approved",
    RejectReview: "Reject review",
    DeleteAll: "Confirm delete all?",
    Name: "Name",
    Size: "Size",
    Preview: "Preview",
    ProgramReview: "Program review",
    ReasonRefusal: "Please fill in the reason for refusal!",
    number: "No release ticket number is selected",
    review: "Review",
    enterKey: "Please enter key words",
    screenshot: "Preview",
    name: "Name",
    group: "Mechanism",
    createTime: "Submission time",
    publisher: " Publisher",
    check: "Check",
    pass: "Approved",
    reject: "Reject",
    materialCheck: "Material review",
    pleaseInputContent: "Please enter review content",
    approve: "Approved",
    rejectReview: "Reject review",
    releaseReview: "Release review",
    resonForReject: "Please enter reason for rejection",
    all: "All",
    waitReview: "Pending review",
    approves: "Pass",
    selectTips: "Please select at least one material",
    selectTips1: "Only supports query data within three months",
    deleteTips: "Are you sure to delete all?",
    deleteRecord: "Delete record",
    singleNo: "Single number",
    loop: "Loop",
    timming: "Timing",
    instream: "In-stream",
    noAdap: "Not adaptive",
    adap: "Adaptive screen size"
  },
  schedule: {
    Screenshot: "Preview",
    ProgramName: "Name",
    Structure: "Structure",
    Resolution: "Resolution",
    CreationTime: "Create",
    operate: "Operate",
    AllLoaded: "All loaded",
    materialsLoaded: "Click to load material",
    NewProgram: "New program",
    DelProgram: "Do you want to permanently delete the currently selected program?",
    DeleteMedia: "Delete media",
    DeleteProgram: "Del program",
    loop: "LOOP",
    timpingPlay: "TIMING",
    emerPlay: "INSERT",
    releaseRecord: "Release record",
    releaseMan: "Release management",
    playNo: "Release number",
    group: "Mechanism",
    releaseType: "Release type",
    releaseNow: "Release now",
    releaseTim: "Release time",
    publisher: " Publisher",
    review: "Check",
    pedReview: "Pending review",
    noReview: "No review",
    noPass: "Not pass",
    pass: "Approved",
    waitRelease: "Wait for release",
    expird: "Expired",
    detail: "Details",
    delete: "Delete",
    deletePlay: "Delete  program",
    deletePlayTip: "Permanently delete the currently selected program?",
    keyWords: "Please enter a query keyword",
    noSelectTip: "No release records selected",
    addPlay: "Add program",
    selectProgram: "Select program list",
    delPro: "Delete Program",
    delProTip: "Do you want to clear all programs?",
    screenshot: "Preview",
    proName: "Name",
    structure: "Structure",
    resolution: "Resolution",
    createTime: "Submission time",
    noProgram: "Currently no programs",
    moveDown: "Can't move down any further",
    moveUp: "Can't move up any further",
    tips: "Tip",
    playList: "Program list",
    terminalList: "Terminal list",
    releaseProp: "Release properties",
    offline: "Offline",
    timimgPlan: "Timing Release",
    user: "User",
    terminalName: "TerminalName",
    terminalState: "Device status",
    publishSate: "Release status",
    planModole: "Play mode",
    playStrategy: "Release strategy",
    playPlan: "Play plan",
    playCount: "Times of play",
    playsCount: "Number of consecutive plays",
    pleaseSelect: "Please select",
    playTimes: "Play time",
    conPlayTime: "Continuous play time",
    publish: "Release",
    customize: "Customize",
    once: "1",
    twice: "2",
    treeTimes: "3",
    fourTimes: "4",
    fiveTimes: "5",
    sixTimes: "6",
    sevenTimes: "7",
    eightTimes: "8",
    nineTimes: "9",
    tenTimes: "10",
    countTips: "The number of times must be at least 1",
    pubSuccessTip: "Release success",
    selectTip1: "Please select at least two programs",
    planPre: "Program preview",
    addPlayStep: "Add plan steps",
    selectDate: "Select date time",
    instreamResver: "Stream Reserve",
    instreamNow: "Stream Now",
    selectTimeTips: "The selection time cannot be earlier than the current time",
    palyTime: "Play time",
    selectStartTime: "Select a Start Time",
    selectEndTime: "Select an End Time",
    conserLoop: "Plays",
    validDate: "Valid Date",
    date: "Date",
    daily: "Daily",
    startTimeTips: "Start time cannot later than end time",
    endTimeTips: "End time cannot earlier than start time",
    startDateTips: "Start date cannot be later than end date",
    endDateTips: "End date cannot earlier than start date",
    saveAplan: "Keep one plan at least",
    check: "Check",
    planSize: "Program Size",
    planName: "Release Name",
    leastTime: "Invalid date",
    NewProgramInfor: "New Program Infor"
  },
  system: {
    StructureName: "StructureName",
    Operate: "Operate",
    NewStructure: "New structure",
    DeleteStructure: "Delete structure",
    Structure: "Structure",
    MsgDeleteStructure: "Permanently delete the current",
    OnDevice: "Turn on device",
    OffDevice: "Turn off device",
    inquiry: "IF",
    on: "on",
    off: "off",
    slaveDevice: "the current or slave device",
    CloseCurrent: "Close current",
    CloseSlave: "Close slave",
    OpenCurrent: "Open current",
    OpenSlave: "Open slave",
    Account: "Please enter your account",
    Name: "Name",
    Role: "Role",
    Grade: "Grade",
    Remark: "Remark",
    RoleName: "Role name",
    Password: "Please enter password",
    ConfirmPass: "Confirm Pass",
    Mail: "Mail",
    DeleteUser: "Delete user",
    DeleteRole: "Permanently delete current role",
    UnblockDevice: "Unblock device",
    banDevice: "Ban device",
    Unblock: "Unblock",
    ban: "Forbidden",
    BanTheCurrent: "Ban the current",
    BannedAffiliate: "Banned affiliate",
    ReleaseTheCurrent: "Release the current",
    ReleaseTheSubordinate: "Release the subordinate",
    AddUser: "Add user",
    ModifyUser: "Modify user",
    inputPassword: "Please enter Confirm Pass",
    noPassword: "Passwords entered twice do not match!",
    inputName: "Please enter name",
    RoleEmpty: "Role name cannot empty",
    StructureEmpty: "Structure name cannot empty",
    AccountEmpty: "Account not allowed empty",
    AccountAstrict: "Account only contain numbers, letters, and underscores!",
    AccountLength: "Please set account length 3~20 characters!!",
    AccountRegistered: "Current account has been registered, please re-enter!",
    AddRole: "Add role",
    RoleRemark: "Role remark",
    RightConfig: "Right config",
    DelRole: "Delete role",
    imageSize1: "Suggest 920x940 pixels PNG format",
    ReplacePicture: "Replace picture",
    LoginLogo: "Login page LOGO",
    imageSize2: "Suggest 360x80 pixels PNG format",
    SystemLogo: "System page LOGO",
    systemSettings: "Other system settings",
    configInformation: "Other config information",
    DailyLimit: "Daily application limit",
    UploadedType: "Uploaded avatar image can only PNG format!",
    UploadedSize: "Size of the uploaded avatar image cannot exceed 2MB!",
    addNode: "Add node",
    EnglishName: "EnglishName",
    ChineseName: "ChineseName",
    delNode: "Permanently delete current role ?",
    AuthorizationType: "Code type",
    Model: "Model",
    Date: "Date",
    AuthorizationCode: "Authorization Code",
    NewAccounts: "New accounts",
    clearTips1: "Whether to clear all current reviewers?",
    clearTips2: "Whether to clear current reviewer?",
    selectReviewer: "Select Reviewers",
    noReviers: "For those who do not have relevant review permissions,",
    createTips: "please create an review account first",
    sameReviwers: "The Next organization shares the same reviewer",
    email: "Mail",
    phone: "Phone",
    lastLogin: "Last login",
    remark2: "Company Address",
    resetPwd: "Reset Password",
    subUser: "Subordinate users",
    NumOfTerminals: "Number of terminals",
    NumOfPro: "Number of programs",
    editPwd: "Change Password",
    oriPwd: "Original password",
    newPwd: "New password",
    confirmPws: "Confirm Pass",
    modifyInfo: "Modify Information",
    changeNick: "Change Nickname",
    changeEmail: "Change Email",
    personalCenter: "Personal Center",
    enterOriPwd: "Enter Original Password",
    enterNewPwd: "Enter New Password",
    confirmPwd: "Please Confirm Pass",
    enterNick: "Please Enter Nickname",
    pwdNoPass: "Password Twice Inconsistent",
    changePwdSucc: "Change password success",
    modiSuccess: "Modified success",
    modiFail: "Modified fail",
    noSet: "Is not set",
    PleaseInputEmail: "Please enter the Email"
  },
  terminal: {
    treeTitle: "Structure grouping",
    Details: "Details",
    online: "Online",
    offline: "Offline",
    list: "List",
    card: "Chart",
    map: "Map",
    keyWord: "Please enter key words",
    refresh: "Refresh",
    add: "Add",
    delete: "Delete",
    deviceName: "Name",
    remark: "Remark",
    resolution: "Resolution",
    types: "Types",
    version: "Version",
    status: "Status",
    operate: "Operate",
    edit: "Modify",
    loading: "Loading",
    allSelect: "Select all spread",
    selected: "Selected",
    selectAll: "Select all on this page",
    selectInMap: "Please select device location on map",
    structure: "Structure",
    selectGroup: "Select structure",
    selectSize: "Please select resolution",
    customize: "Customize",
    followTerminal: "Follow Terminal",
    selectSn: "Please select SN",
    deviceTip: "Device name cannot empty",
    snTip: "SN cannot be empty",
    sizeTip: "Screen resolution cannot be empty",
    deviceType: "Device type",
    cancel: "Cancel",
    confirm: "Confirm",
    delDevice: "Delete terminal",
    delDevTip: "Permanently delete the selected terminal?",
    onlineTotal: "Online Statistics",
    reboot: "Reboot",
    offscreen: "Screen off ",
    onscreen: "Screen on",
    timeTask: "Timing command",
    conBright: "Bright adjust",
    conVoice: "Sound adjust",
    relay: "Relay switch",
    timeZone: "Time zone calibration",
    signalChange: "Signal switching",
    synScreen: "Multi-screen synchronization",
    timePlay: "Timing play switch",
    timeOn: "Timingswitch",
    wTip: "Resolution W is empty",
    hTip: "Resolution H is empty",
    xTip: "Position X is empty",
    yTip: "Position y is empty",
    mapTip: "Zoom out on the map to check the table information! ! !",
    selectTip: "No device selected",
    deviceDetail: "Device Details",
    playList: "Program list",
    affi: "Affiliation:",
    screenType: "Screen type",
    boxTime: "Box clock",
    noData: "No data",
    currTimeZone: "Current time zone",
    deviceLan: "Device language",
    deviceZoom: "Storage",
    runState: "Run status",
    runTime: "Continue run",
    lastHeart: "Recent heartbeat",
    timeOrder: "Timing command",
    comAddr: "Server address",
    voice: "Sound",
    birght: "Brightness",
    no: "Code",
    proName: "Program Name",
    power: "Relay",
    milRefresh: "Seconds, auto refresh",
    viewPho: "View original photo",
    setTimeZone: "Set time zone",
    terminalUp: "Terminal upgrade",
    upType: "Upgrade method",
    cloudUp: "Cloud upgrade",
    localUp: "Local file upgrade",
    clickUp: "Click to upload",
    name: "Name",
    type: "Model",
    verInfo: "Version Information",
    schedule: "Schedule",
    noUp: "No need upgrade",
    waitStar: "Wait start",
    downExc: "Download exception",
    downOK: "Download success",
    upTip: "Upgrading, will restart auto when complete",
    checkError: "validators fail",
    erroBack: "Abnormal feedback",
    downError: "Download fail",
    dowNum: "1 selected",
    upTips1: "Note: In order to prevent data loss, please backup data, the device will restart auto after upgrade is completed,",
    upTips2: "please do not power off during upgrade process",
    upGr: "Upgrade",
    serverAddEdit: "Server address modify",
    serEdTit: "Remove terminal to the new server",
    newAddr: "New server address",
    test: "Test",
    user: "User",
    psw: "Password",
    remove: "Remove",
    conRes: "Confirm restart",
    conOnSc: "Confirm open screen",
    upTips3: "Please use zip or apk file",
    testOk: "Test passed",
    testFail: "Test failed",
    inputTips1: "Please fill in username and password",
    opOk: "Operate success",
    mapTip1: "Please mark device location on map",
    addDetail: "Details address",
    lng: "Longitude",
    lat: "Latitude",
    matTip2: "Failed to get address, please try later",
    orderTip: "Confirm restart selected terminal screen?",
    orderTip1: "Confirm close selected terminal screen?",
    orderTip2: "Confirm to open selected terminal screen?",
    scSetting: "Schedule settings",
    selectTip1: "Please select at least two programs",
    selectTip2: "Add timing command",
    selectTip3: "Please select template action data",
    conOrder: "Operation commander",
    action1: "Program switch",
    action2: "Bright adjust",
    action3: "Volume adjust",
    action4: "Screen off ",
    action5: "Screen on",
    action6: "Source switch",
    action7: "Relay off",
    action8: "Relay on",
    action9: "Screen off ",
    action10: "Screen on",
    value: "value",
    acVa1: "HDMI priority",
    acVa2: "Async signal",
    acVa3: "Sync signal",
    excTime: "Execution time",
    dateOk: "Valid date",
    noLimit: "No limit",
    isWeekLi: "Valid week",
    oper: "Operate",
    newTem: "Create template",
    savTem: "Save template",
    addTem: "add scheduling template",
    temName: "Template name",
    temTip1: "Please enter template name",
    relayOn: "Relay switch",
    timeZoneSe: "Time zone selection",
    hdmiSi: "HDMI signal source",
    inSin: "Internal signal source",
    openMulti: "Enable multi-screen Sync playback",
    gps: "GPS Sync",
    localW: "LAN sync",
    closeScreen: "Turn off multi-screen sync playback",
    openTimePlay: "Turn on timing playback",
    closeTimePlay: "Turn off timing playback",
    openTime: "Turn on timing",
    onTime: "boot time",
    offTime: "Shutdown time",
    excDate: "Execution date",
    closeTime: "Close timing",
    onlyG: "Only supports advertising machine devices",
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    noDeviceSelected: "No device selected",
    group: "Mechanism",
    onlineNum: "Online Qty",
    offlineNum: "Offline Qty",
    totalNum: "Device Qty",
    noOrderExc: "No commands have been executed yet",
    createTime: "Submission time",
    orderName: "Command name",
    aimDevice: "Target device",
    orderStatus: "Command status",
    timeOut: "Timeout feedback",
    excSuccess: "Execution succeed",
    sent: "Sent",
    timeOpenNo: "Timing switch: no data yet",
    timeOpen: "Timing switch: on",
    deviceOff: "Device offline",
    timeOpenTip: "Timing playback is on",
    timeCloseTip: "Timing playback is off",
    programList: "Program list",
    playTime: "Duration",
    loop: "Loop",
    excSta: "Executive standard",
    timingPlay: "Timing play",
    playCount: "Times of play",
    proDelete: "Delete program",
    proDeleteTip: "Delete the program?",
    timePlayOpenTip: "Timing playback start success",
    timePlayCloseTip: "Timing playback close success",
    programChangeTip: "Program switch success",
    programIsPlaying: "Program is playing",
    powerList: "Onboard power supply",
    allOpen: "All open",
    allClose: "All close",
    open: "Open",
    close: "Close",
    mulCard: "Multi function card",
    firstChannel: "First channel",
    secondChannel: "Second channel",
    thirdChannel: "Third channel",
    fourthChannel: "Fourth channel",
    fifthChannel: "Fifth channel",
    sixthChannel: "Sixth channel",
    seventhChannel: "Seventh channel",
    eighthChannel: "Eighth channel",
    syncToTerminal: "Sync to terminal",
    allOpenTip: "Turn on/off the multifunction card?",
    operComman: "Operation command",
    brigValue: "Volume",
    method: "Method",
    speDate: "Specified date",
    speWeek: "Specified week",
    isDateLimit: "Is there a date limit?",
    isWeekLimit: "Whether week limit",
    edits: "Edit",
    timingOn: "Timing command on",
    timingOff: "Timing command off",
    addTimingCom: "Add timing command",
    ban: "Forbidden",
    opend: "Open",
    closed: "Close",
    timePlayTips: "Timed playback, unable to switch",
    addDevice: "Add device",
    deviceTypeTip: "Please select device type",
    key: "Key",
    groupTips: "Organization structure cannot be empty",
    least: "Remaining",
    arrangeTip: "Please select between 0-100",
    saveSuccess: "Save success",
    tempExit: "Template already exists, please change the name",
    command: "Command",
    isSent: "Sent to",
    execSuccess: "execution succeed",
    sented: "Sent to",
    execFail: "Timeout feedback",
    runStatus: "Online & On Screen & On Play",
    timeLimit: "Please space",
    timeLimitTip: "Seconds, and then do the operation, there is still left",
    seconds: "Second",
    syncPlay: "Play in sync",
    signalStatus: "Signal source state",
    automatic: "自动",
    zh: "简体中文",
    en: "英语",
    vn: "越南语",
    isopend: "Now on",
    isclosed: "Not open",
    syncGps: "GPS同步",
    syncNet: "网络同步",
    snTipLan: "Please enter capital letters and numbers",
    batchAdd: "batch add",
    batchUpdate: "batch upgrading",
    live: "Real-time streaming",
    camera: "camera",
    currentStreamAddress: "Current stream address：",
    setParameters: "Set Parameters",
    tips1: "Get playback real-time picture",
    tips2: "Current stream address：",
    buttonCopy: "Copy ",
    Resolution: "Resolution",
    FrameRate: "Frame rate",
    CentralControl: "Central Control",
    EditInstruction: "Edit Instruction",
    AddInstruction: "Add Instruction"
  },
  PE: {
    Setting: "Setting",
    Save: "Save",
    Release: "Release",
    Quit: "Quit",
    ExitEditProgram: "Exit will discard  currently edited program",
    DragMaterial: "Drag the material file here",
    SaveWait: "Screenshots and saving, please wait ...",
    ProgramList: "Window List",
    multimedia: "Multimedia",
    AddMultimedia: "Add multimedia",
    Insert: "Insert at current position",
    properties: "Properties",
    materialNull: "",
    Uploaded: "Uploaded",
    AllLoaded: "All loaded",
    materialsLoaded: "Click to load material",
    Text: "Text",
    Digital: "Digital clock",
    Analog: "Analog clock",
    Weather: "Weather",
    Timing: "Timing",
    Countdown: "Countdown",
    StreamMedia: "Stream media",
    RSS: "RSS",
    Window: "Window",
    Picture: "Picture",
    Video: "Video",
    Delete: "Delete",
    Webpage: "Webpage",
    OneLayerUp: "One layer up",
    OneLayerDown: "One layer down",
    Top: "Top",
    Bottom: "Bottom",
    Full: "Full",
    HorizontalFull: "Horizontal full",
    VerticalFull: "Vertical full",
    VerticalDown: "Vertical down",
    VerticalMiddle: "Vertical middle",
    VerticalTop: "Vertical top",
    HorizontalLeft: "Horizontal left",
    HorizontalCenter: "Horizontal center",
    HorizontalRight: "Horizontal right",
    ProgramName: "Name",
    Structure: "Structure",
    DeviceType: "Dvice type",
    Resolution: "Resolution",
    CustomResolution: "Custom resolution",
    Device: "Device",
    SelectDevice: "Select device",
    SelectTerminal: "Select publishing Terminal",
    TerminalName: "Terminal Name",
    DeviceStatus: "Status",
    Offline: "Offline",
    AdaptiveScreen: "Adaptive screen size playback",
    Tip: "Tip",
    Thumbnail: "Thumbnail",
    Name: "Name",
    version: "Version number",
    Title: "Title",
    TimerMode: "Timer Mode",
    RelativeTime: "Relative Time",
    AbsoluteTime: "Absolute Time",
    DisplayMode: "Display Mode",
    Day: "Day",
    Hour: "Hour",
    Minutes: "Minutes",
    Second: "Second",
    EditStyle: "Edit Style",
    DisplayUsage: "Edit Style",
    ARow: "DT",
    MultiRow: "MT",
    FontFamily: "Font Family",
    BackgroundColor: "Back Ground Color",
    FontColor: "Font Color",
    PlayTime: "Program Duration",
    Describe: "Describe",
    HourMark: "Hour Mark",
    HourHand: "Hour Hand",
    MinutesMark: "Minutes Mark",
    MinutesHand: "Minutes Hand",
    background: "background",
    secondHand: "Second Hand",
    DateAndDay: "Date And Day",
    Display: "Display",
    SelectTimeZone: "Select Time Zone",
    Scale: "Scale",
    ConstrainProportions: "Constrain Pro-Portions",
    EnterTheAnimation: "Enter The Animation",
    TheEntryTime: "The Entry Time",
    Data: "Data",
    Time: "Time",
    ChineseCalendar: "Calendar",
    Week: "Week",
    DateFormat: "DateFormat",
    Font: "Font",
    Roll: "Roll",
    FlipOver: "FlipOver",
    Motionless: "Motionless",
    RollingDirection: "Rolling Direction",
    RollingVelocity: "Rolling Velocity",
    FromLeftToRight: "From Left To Right",
    FromRightToLeft: "From Right To Left",
    FromTopToBottom: "From Top To Bottom",
    FromTheBottomUp: "From the Bottom Up",
    Attribute: "Attribute",
    AttendedMode: "Attended Mode",
    EndToEnd: "End To End",
    VolumeAdjust: "Volume Adjust",
    Duration: "Duration",
    Address: "Address",
    City: "City",
    Temp: "Temp",
    WindPower: "Wind Power",
    Humidity: "Humidity",
    DressingIndex: "Dressing Index",
    PlayTheWay: "Play The Way",
    TimeFormat1: "00:00:00:00",
    TimeFormat2: "00D 00H 00M 00S"
  }
}